import { makeAccountInput } from '@/modules/entities/EntitySubforms/utils/shared/accounts.utils';
import {
  estateInclusionStatusToApiTypeMap,
  mapStateInEstateStatusToApi,
  nonTrustEntityTaxStatusToApiTypeMap,
} from '@/modules/entities/EntitySubforms/utils/shared/taxStatus.utils';
import { getTaxStatusValuesFromEntityType } from '@/modules/entities/TaxStatusSubform/TaxStatusSubform.utils';
import { EntityType } from '@/modules/entities/types/EntityType';
import {
  AugmentedCreateDonorAdvisedFundInput,
  AugmentedCreateEntityInput,
  AugmentedCreatePrivateFoundationInput,
} from '@/types/schema';

import {
  CREATE_ENTITY_SHORT_FORM_NAMESPACE,
  EntityShortFormShape,
} from '../CreateEntityShortForm.types';
import {
  getCreateEntityInputCommonProps,
  MakeCreateEntityInputParams,
  makeCreateMultiplePrincipalInputs,
} from './CreateEntityShortForm.common';

export function makeCreateDafInput(
  formInput: EntityShortFormShape,
  householdId: string,
  params: MakeCreateEntityInputParams
): AugmentedCreateEntityInput {
  const input: AugmentedCreateEntityInput = {
    create: {
      ...getCreateEntityInputCommonProps(formInput, householdId, params),
    },
    withDonorAdvisedFund: makeCharitableNonTrustEntityInput(
      formInput,
      householdId
    ),
  };

  return input;
}

export function makeCreatePrivateFoundationInput(
  formInput: EntityShortFormShape,
  householdId: string,
  params: MakeCreateEntityInputParams
): AugmentedCreateEntityInput {
  const input: AugmentedCreateEntityInput = {
    create: {
      ...getCreateEntityInputCommonProps(formInput, householdId, params),
    },
    withPrivateFoundation: makeCharitableNonTrustEntityInput(
      formInput,
      householdId
    ),
  };

  return input;
}

export function makeCharitableNonTrustEntityInput(
  formInput: EntityShortFormShape,
  householdId: string
):
  | AugmentedCreateDonorAdvisedFundInput
  | AugmentedCreatePrivateFoundationInput {
  const { nonTrustEntityTaxStatus } = getTaxStatusValuesFromEntityType(
    formInput[CREATE_ENTITY_SHORT_FORM_NAMESPACE].entityType as EntityType
  );

  return {
    create: {
      displayName: formInput.createEntityShortForm.name,
      householdID: householdId,
      inEstateStatus:
        estateInclusionStatusToApiTypeMap[
          formInput.createEntityShortForm.estateInclusionStatus
        ],
      stateInEstateStatus: mapStateInEstateStatusToApi(
        formInput.createEntityShortForm.stateInEstateStatus
      ),
      taxStatus: nonTrustEntityTaxStatus
        ? nonTrustEntityTaxStatusToApiTypeMap[nonTrustEntityTaxStatus]
        : undefined,
    },
    withDonors: makeCreateMultiplePrincipalInputs(formInput, householdId),
    withDesignerAccount: makeAccountInput(formInput, householdId),
  };
}
